import React from 'react';

const LedgerContext = React.createContext(null);

export default LedgerContext;
